import API from "../../restAPI";
const Api = new API();

export default class LocationAPI {

    //Get location by id
    getLocationById(locationId) {
        return Api.request(
            `/pr-locations/${locationId}`,
            {},
            "GET",
        );
    }

    //Get Country
    getSearchedCountry(name) {
        return Api.request(
            `/pr-countries`,
            {},
            "GET",
            `filter=%7B%22limit%22:15,%22where%22:%7B%22name%22:%7B%22like%22:%22%25${name}%25%22%7D%7D%7D`
        );
    }

    //Get Country
    getSearchedState(countryId, name) {
        console.log("countryId,",countryId)
        return Api.request(
            `/pr-states`,
            {},
            "GET",
            `filter=%7B%22limit%22:15,%22where%22:%7B%22name%22:%7B%22like%22:%22%25${name}%25%22%7D,%22countryId%22:${countryId}%7D%7D`
        );
    }

    //Get Country
    getSearchedCity(countryId, stateId, name) {
        return Api.request(
            `/pr-cities`,
            {},
            "GET",
            `filter=%7B%22limit%22:15,%22where%22:%7B%22name%22:%7B%22like%22:%22%25${name}%25%22%7D,%22countryId%22:${countryId},%22stateId%22:${stateId}%7D%7D`
        );
    }
}

